import React, { useContext } from 'react';
import { Box, DialogTitle, Stack } from '@mui/material';
import TopAreaSpace from 'components/TopAreaSpace';
import useIsDesktop from 'hooks/useIsDesktop';
import CloseButton from './CloseButton';
import { OverlayContext } from './constants';

function Header({
  children, showClose = true, ...props
}) {
  const { onClose, fullScreen } = useContext(OverlayContext);
  const isDesktop = useIsDesktop();
  const closeIcon = onClose && showClose && (isDesktop || fullScreen) && (
    <CloseButton />
  );
  return (
    <>
      { fullScreen && <TopAreaSpace /> }
      <DialogTitle
        {...props}
        sx={{
          height: 65,
          py: 0,
          display: 'flex',
          alignItems: 'center',
          ...props.sx,
        }}
        noWrap
      >
        <Stack direction="row" alignItems="center" spacing={1} width="100%">
          {closeIcon}
          <Box sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            pl: !closeIcon ? 1 : undefined,
          }}
          >
            {children}
          </Box>
        </Stack>
      </DialogTitle>
    </>

  );
}
export default Header;
